import { WorkspaceCategoryMSX, WorkspaceCategoryPC, WorkspaceMSX, WorkspacePC } from './Models/SupportTopicMetadata';
import { Settings } from './Settings';

export class Constants {
  private static instance: Constants;
  private settings = Settings.getInstance().ClientSettings;
  private partnerSupportApiPath = this.settings.PartnerSupportApiEndpoint;
  private partnerApiEndpoint = this.settings.PartnerApiEndpoint;
  private serviceDeskEndpoint = this.settings.ServiceDeskEndpoint;
  private partnerCenterHomeUrl = this.settings.PartnerCenterHomeUrl;
  private customerServiceAdminEndpoint = this.settings.CustomerServiceAdminEndpoint;
  private partnerApiTrafficManagerEndpoint = this.settings.PartnerApiTrafficManagerEndpoint;
  private partnerSupportAdminApiPath = this.settings.PartnerSupportAdminApiEndpoint;
  private supportApimEndpoint = this.settings.SupportApimEndpoint;

  public static getInstance = () => {
    if (!Constants.instance) {
      Constants.instance = new Constants();
    }
    return Constants.instance;
  };

  private constructor() {}
  get PartnerManagedServicesEndpoint() {
    return this.partnerApiEndpoint + '/v1/customers';
  }
  get ServiceRequestEndpoint() {
    return this.partnerSupportApiPath + '/v1/servicerequests';
  }
  get PartnerServiceCustomerEndpoint() {
    return this.partnerSupportApiPath + '/v1/customers';
  }

  get CustomerServiceAdminEndpoint() {
    return this.customerServiceAdminEndpoint;
  }

  get ServiceRequestQuery() {
    return {
      defaultPageSize: '10',
    };
  }

  get MaxFileSize() {
    return {
      ThreeMB: 3145728,
      TenMB: 10485758,
    };
  }
  get PartnerSupportDataFileName() {
    return '_ScopedTemplateData.json';
  }

  get DescriptionTemplateId() {
    return 'problem_description';
  }

  get MaxDescriptionLength() {
    return {
      nonCosmic: 99500,
      cosmic: 4000,
    };
  }

  get ServiceRequestActivityTypes() {
    return {
      email: 'email',
      notes: 'notes',
      requestDetails: 'details',
    };
  }

  get MaxTitleLength() {
    return 255;
  }

  get MaxEmailCcListLength() {
    return 20;
  }

  get PartnerSupportServiceEndpoint() {
    return this.partnerSupportApiPath;
  }

  get SupportApimEndpoint() {
    return this.supportApimEndpoint;
  }

  get PartnerSupportServiceAdminEndpoint() {
    return this.partnerSupportAdminApiPath;
  }

  get PartnerApiTrafficManagerEndpoint() {
    return this.partnerApiTrafficManagerEndpoint;
  }

  get PartnerServiceRequestEndpoint() {
    return '/pcv/partnerservicerequests/list';
  }

  get ExternalPartnerNewServiceRequestUrl() {
    return 'https://support.azure.cn/support/support-o365';
  }

  get PartnerSupportServiceAdminApiEndpoints() {
    return {
      ServiceIncidentsApiPath: this.PartnerSupportServiceAdminEndpoint + '/v1/serviceincidents',
    };
  }

  get PartnerCenterHomeUrl() {
    return this.partnerCenterHomeUrl;
  }

  get DtmUrl() {
    return 'https://client.dtmnebula.microsoft.com/msa/home/index?workspaceid=';
  }
  get VirtualDirectory() {
    return {
      SupportServiceRequests: 'dashboard/support',
      InternalTools: 'internal/tools',
    };
  }
  get Severity() {
    return {
      Minimal: 'Minimal',
      Moderate: 'Moderate',
      Critical: 'Critical',
    };
  }
  get DateFormat() {
    return 'MM/DD/YYYY';
  }

  get SupportTopicsType() {
    return {
      Issue: 'issue',
      Problem: 'problem',
    };
  }

  get CommonUXPortalHeaderElements() {
    return {
      onedashHeaderWrapper: 'onedash-header-wrapper',
      onedashBannerNotification: 'onedash-banner-notifications',
    };
  }

  get SupportAppBreadcrumb() {
    return {
      breadcrumbParentId: 'breadcrumb-parent',
      ElementTagName: 'shell_he-breadcrumb-item',
    };
  }

  get ThemeStringsCommonUXEnablers() {
    return {
      darkModeCommonUx: 'darkMode',
      enablersThemeLight: 'he-theme-light',
      enablersThemeDark: 'he-theme-dark',
    };
  }

  get ProgramId() {
    return {
      AllProgramsId: 'allPrograms',
      GeneralProgramId: 'general',
      CspProgramId: 'csp',
      MpnProgramId: 'mpn',
      IncentivesProgramId: 'incentives',
      ReferralsProgramId: 'referrals',
      IsvProgramId: 'isv',
      SamProgramId: 'SAM',
      OemProgramId: 'OEM',
      OtherProgram: 'other',
      Commercialmarketplace: 'commercialmarketplace',
      DeveloperToolsProgramId: 'developertools',
      MicrosoftDynamicsProgramId: 'microsoftdynamics',
      ProductSupportProgramId: 'productsupport',
      VolumeLicensingProgramId: 'volumelicensing',
      OfficeStoreProgramId: 'officestore',
    };
  }

  get Workspace() {
    return {
      WorkspaceProperty: 'workspace',
      WorkspaceCategoryProperty: 'workspaceCategory',
      None: 'None',
    };
  }

  get WorkspaceId() {
    return {
      AppsAndGamesId: WorkspacePC.AppsAndGames,
      BenefitsId: WorkspacePC.Benefits,
      BillingId: WorkspacePC.Billing,
      ClaimsId: 'um7pkr8',
      CollaborateId: WorkspacePC.Collaborate,
      CustomersId: WorkspacePC.Customers,
      CustomerResearchId: 'as87jkl',
      EdgeId: WorkspacePC.Edge,
      HardwareId: '6z0naak',
      IncentivesId: WorkspacePC.Incentives,
      InsightsId: WorkspacePC.Insights,
      MembershipId: WorkspacePC.Membership,
      MarketplaceOffersId: WorkspacePC.MarketplaceOffers,
      ReferralsId: WorkspacePC.Referrals,
      EarningsId: WorkspacePC.Earnings,
      PricingId: WorkspacePC.Pricing,
      QuotesId: '99gy1am',
      QuotesHelpId: 'd8j54ls',
      HelpAndSupportId: 'ck2ic0y',
      SecurityId: 'vv27aob',
      // MSX
      AccountPlans: WorkspaceMSX.AccountPlans,
      Accounts: WorkspaceMSX.Accounts,
      CALC: WorkspaceMSX.CALC,
      Compensation: WorkspaceMSX.Compensation,
      Contacts: WorkspaceMSX.Contacts,
      DealAssistance: WorkspaceMSX.DealAssistance,
      Engagements: WorkspaceMSX.Engagements,
      Leads: WorkspaceMSX.Leads,
      Opportunities: WorkspaceMSX.Opportunities,
      Partners: WorkspaceMSX.Partners,
      UserProvisioning: WorkspaceCategoryMSX.UserProvisioning,
      Proposals: WorkspaceMSX.Proposals,
      SalesAccelerator: WorkspaceMSX.SalesAccelerator,
    };
  }

  get WorkspaceCategoryId() {
    return {
      AccountSettingsId: WorkspaceCategoryPC.AccountSettings,
      ActionCenterId: WorkspaceCategoryPC.ActionCenter,
      ApiAndIntegrationSupportId: WorkspaceCategoryPC.ApisAndIntegration,
      EnrollmentId: WorkspaceCategoryPC.Enrollment,
      ApiAndIntegrationSupportOldId: 'ApisAndIntegration',
      EnrollmentOldId: 'Enrollment',
      DeveloperTools: 'DeveloperTools',
      MicrosoftDynamics: 'MicrosoftDynamics',
      ProductSupport: 'ProductSupport',
      VolumeLicensing: 'VolumeLicensing',
    };
  }

  get WayfinderModelIds() {
    return {
      OtherPortalsId: ['1bd2a485-21b4-1085-4854-76b5b13a6c8f'],
      AgentFlowIds: {
        'a7c5a2d2-e9fb-cde9-ae4d-f57a17118297': 'SCDesign',
      } as { [key: string]: string },
    };
  }

  get TimeZone() {
    return {
      PST: 'PST',
      UTC: 'UTC',
    };
  }

  get NoCache() {
    return 'no-cache';
  }

  get HealthStatus() {
    return {
      Good: 'Good',
      Warning: 'Warning',
      Error: 'Error',
      Information: 'Information',
    };
  }

  get ServiceIncidentStatus() {
    return {
      Active: 'Active',
      Resolved: 'Resolved',
    };
  }

  get AccessLevel() {
    return {
      Readonly: 'readonly',
      ReadWrite: 'readwrite',
    };
  }

  get Persona() {
    return {
      MSUSer: 'msuser',
      Partner: 'partner',
      MSA: 'msa',
      SupportAgentAdmin: 'AgentAdmin',
      MSTenantUser: 'mstenantuser',
    };
  }

  get PersonaClaims() {
    return {
      CaseReview: 'CaseReview',
      BulkCaseReviewAssignment: 'BulkCaseReviewAssignment',
      MsxAgentAdmin: 'MsxAgentAdmin',
    };
  }

  get TicketStatus() {
    return {
      open: 'open',
      closed: 'closed',
      attentionNeeded: 'attentionNeeded',
    };
  }

  get PartnerClaimsCloudInstanceNames() {
    return {
      global: 'global',
    };
  }
  get Routes() {
    return {
      SupportRoot: 'support',
      ServiceRequests: 'servicerequests',
      ServiceRequestsMsxSeller: 'servicerequests/seller',
      Customers: 'customers',
      CaseReview: 'casereview',
      ServiceRequestsCreate: 'servicerequests/create',
      ServiceRequestsCreateMsxSeller: 'servicerequests/create/seller',
      MsaUnauthorized: 'MsaUnauthorized',
      ServiceHealth: 'service-health-status',
      ServiceHealthAdmin: 'service-health-status/admin',
      SupportTopicMetadataAdmin: 'support-topic-metadata-admin',
      PublicServiceHealth: 'service-health-status',
      OldPublicServiceHealth: 'csp/service-health-status',
      CaseReviews: 'casereviews',
      SupportV2: 'v2',
      Activity: 'activity',
      UploadCases: 'uploadcases',
      Details: 'details',
    };
  }

  get getFlights() {
    return {
      PFXSupportBookingsInternalTest: 'PFXSupportBookingsInternalTest',
      WorkspaceBookings: 'PSX_Support_WorkspaceBookings',
      PFXSupportWorkspaces: 'pfx-support-workspaces',
      PFXProductWCDropdown: 'PFXProductWCDropdown',
      PFXTopicWCDropdown: 'PFXTopicWCDropdown',
      PFXSubTopicWCDropdown: 'PFXSubTopicWCDropdown',
      PFXUnauthWorkspaceDropdown: 'PFXUnauthWorkspaceDropdown',
      PFXWorkspaceDropdown: 'PFXWorkspaceDropdown',
      PFXNewRequestText: 'PFXNewRequestText',
      RemoveUpdateEmailLanguage: 'RemoveUpdateEmailLanguage', //Remove the update for email language
      PFXCaseReviewADOConsumeUserToken: 'PFXCaseReviewADOConsumeUserToken',
      DeepLinkToAIAssistant: "DeepLinkToAIAssistant",
      //Not appconfig flights
      WorkspacePreview: 'WorkspacePreview',
    };
  }

  get getAzureSelfHelpSupportedLocales() {
    return {
      en_US: 'en-US',
      es_ES: 'es-ES',
      fr_FR: 'fr-FR',
      cs_CZ: 'cs-CZ',
      hu_HU: 'hu-HU',
      it_IT: 'it-IT',
      pl_PL: 'pl-PL',
      zh_TW: 'zh-TW',
      zh_CN: 'zh-CN',
      de_DE: 'de-DE',
      ja_JP: 'ja-JP',
      ko_KR: 'ko-KR',
      nl_NL: 'nl-NL',
      pt_BR: 'pt-BR',
      pt_PT: 'pt-PT',
      ru_RU: 'ru-RU',
      sv_SE: 'sv-SE',
      tr_TR: 'tr-TR',
    };
  }

  get InputNames() {
    return {
      Email: 'email',
      PhoneNumber: 'phoneNumber',
      FirstName: 'firstName',
      LastName: 'lastName',
      Description: 'description',
      Title: 'title',
      CountryCode: 'countryCode',
      AgentLocale: 'agentLocale',
      EmailCcList: 'emailCcList',
    };
  }

  get getNotFoundPath() {
    return '/dashboard/support/notfound';
  }
  get getRegex() {
    return {
      PhoneRegex: '^((\\()?[+]?(d|\\-|\\(|\\)|\\.|\\s)*(\\d|\\-|\\(|\\)|\\.|\\s)+(\\d|\\-|\\(|\\)|\\.)*)$',
      EmailRegex:
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",
      XssRegex: '[<>]',
      FullXssRegex: '[<>();]',
    };
  }

  get gotToCustomerPage() {
    return {
      commerceCustomer: 'commerce/customers',
      list: 'list',
      serviceRequests: 'servicerequests',
    };
  }

  get TraceTypes() {
    return {
      Information: 'Information',
      Error: 'Error',
      ActionSuccess: 'Action succeeds',
      ActionFail: 'Action failed',
      TrackEvent: 'Track event',
    };
  }
  get TraceTags() {
    return {
      HttpRequest: 'HttpRequest',
      HttpResponse: 'HttpResponse',
      JavascriptError: 'Javascript error',
    };
  }
  get actionTypes() {
    return {
      startRequestContinue: 'Custom Event: StartRequestContinue',
      solutionsContinue: 'Custom Event: SolutionNeedMoreHelpYes',
      startRequestCancel: 'Custom Event: StartRequestCancel',
      detailsCancel: 'Custom Event: DetailsCancel',
      reviewSolution: 'Custom Event: ReviewSolution',
      landOnSolution: 'Custom Event: LandOnSolution',
      solutionCancel: 'Custom Event: SolutionNeedMoreHelpNo',
      detailsSelectDifferentIssue: 'Custom Event: DetailsSelectDifferentIssue',
      detailsReviewSolutions: 'Custom Event: DetailsReviewSolutions',
      solutionSelectDifferentIssue: 'Custom Event: SolutionSelectDifferentIssue',
      selectSupportTopicFromCategories: 'Custom Event: SelectSupportTopicFromCategories',
      supportParentTopic: 'Custom Event: SelectSupportParentTopic',
      supportTopicFilter: 'Custom Event: supportTopicFilterByProgram',
      solutionClickLink: 'Custom Event: SolutionClickLink',
      createTicket: 'Custom Event: CreateTicketSubmitted',
      newRequest: 'Custom Event: NewRequest',
      scopedTemplateUsage: 'Custom Event: ScopedTemplateFieldsUsage',
      outageWarning: 'Custom Event: PotentialOutageWarning',
      guestContinue: 'Custom Event: CreateTicketAsGuestMode',
      phoneSupportExpand: 'Custom Event: SelectPhoneSupportExpand',
      phoneSupportCollapse: 'Custom Event: SelectPhoneSupportCollapse',
      searchQueryEntered: 'Custom Event: SearchQueryEntered',
      selectSupportTopicFromSearch: 'Custom Event: SelectSupportTopicFromSearch',
      exitFromSearch: 'Custom Event: ExitFromSearch',
      redirectToAgentView: 'Custom Event: redirectToAgentView',
      redirectToPartnerView: 'Custom Event: redirectToPartnerView',
      serviceRequestUpdate: 'Custom Event: ServiceRequestUpdate',
      selectBrowseTopics: 'Custom Event: BrowseTopicsSelected',
      SolutionsDeepLinkBySeamId: 'Custom Event: SolutionsDeepLinkbySeamId',
      SolutionsDeepLinkBySapId: 'Custom Event: SolutionsDeepLinkBySapId',
      EmptyProgramClaims: 'Custom Event: EmptyProgramClaims',
      UserUnauthorized: 'Custom Event: UserUnauthorized',
      topTopicClicked: 'Custom Event: TopTopicClicked',
      clientSideProblem: 'Custom Event: ClientSideProblem',
      customerDetailsView: 'Customer Event: CustomerTicketDetailsView',
      customerServiceRequestCreate: 'Customer Event: CustomerServiceRequestCreate',
      CaseReviewAdoCreateJsonError: 'Customer Event: CaseReviewAdoCreateJsonError',
      CaseReviewAdoCreateError: 'Customer Event: CaseReviewAdoCreateError',
      serviceRequestAppointmentCreate: 'Custom Event: serviceRequestAppointmentCreate',
      serviceRequestAppointmentReschedule: 'Custom Event: serviceRequestAppointmentReschedule',
      serviceRequestAppointmentCancel: 'Custom Event: serviceRequestAppointmentCancel',
      serviceRequestAppointmentAvailable: 'Custom Event: serviceRequestAppointmentAvailable',
      serviceRequestAppointmentShown: 'Custom Event: serviceRequestAppointmentShown',
      serviceRequestAppointmentError: 'Custom Event: serviceRequestAppointmentError',
      recommendationsApiReturn: 'Custom Event: recommendationsApiReturn',
      selectSupportTopicFromRecommendation: 'Custom Event: selectSupportTopicFromRecommendation',
      selectSupportTopic: 'Custom Event: SelectSupportTopic',
      CustomerRequest_LeftNavClick: 'Custom Event: CustomerRequest_LeftNavClick',
      HandleDuplicateTicketsForTopicId: 'Custom Event: HandleDuplicateTicketsForTopicId',
      BlockedWithDuplicateCheckForTopicId: 'Custom Event: BlockedWithDuplicateCheckForTopicId',
      UnblockedWithDuplicateCheckForTopicId: 'Custom Event: UnblockedWithDuplicateCheckForTopicId',
      ServiceRequestStatusUpdate: 'Custom Event: ServiceRequestStatusUpdate',
      ServiceRequestNotesUpdate: 'Custom Event: ServiceRequestNotesUpdate',
      ServiceRequestAttachmentsUpdate: 'Custom Event: ServiceRequestAttachmentsUpdate',
      serviceCallRequestAppointmentCreate: 'Custom Event: serviceCallRequestAppointmentCreate',
      serviceCallRequestAppointmentDelete: 'Custom Event: serviceCallRequestAppointmentDelete',
      serviceCallRequestAppointmentAvailableTimes: 'Custom Event: serviceCallRequestAppointmentAvailableTimes',
      serviceCallRequestAppointmentGet: 'Custom Event: serviceCallRequestAppointmentGet',
      newRequestButtonClicked: 'Custom Event: NewRequestButtonClicked',
      chinaExternalRequestButtonClicked: 'Custom Event: chinaExternalRequestButtonClicked',
      chinaExternalRequestButtonClickedFromWorkspace: 'Custom Event: chinaExternalRequestButtonClickedFromWorkspace',
      deepLinkWithCurrentStateFunc: 'Custom Event: deepLinkWithCurrentStateFunc',
      panelFoundByObservable: 'Custom Event: panelFoundByObservable',
      shouldRedirectToDeepLink: 'Custom Event: shouldRedirectToDeepLink',
      createFlowDeepLinkSetFromUnAuth: 'Custom Event: createFlowDeepLinkSetFromUnAuth',
      openAIAssistantDeepLinkFromUnAuth: 'Custom Event: openAIAssistantDeepLinkFromUnAuth',
      repairItemAdoPathDefault: 'Custom Event: defaultPathChosenForAdoRepairItemAreaPath',
      apolloSolutionEvent: 'Custom Event: ApolloSolutionEvent',
      unAuthLoadSuccessEvent: 'Custom Event: unAuthLoadSuccessEvent',
      unAuthGuestModeClickEvent: 'Custom Event: unAuthGuestModeClickEvent',
      unAuthRedirectToDashboardEvent: 'Custom Event: unAuthRedirectToDashboardEvent',
      unAuthProceedToIssueDetailsEvent: 'Custom Event: unAuthProceedToIssueDetailsEvent',
      unAuthNewRequestEvent: 'Custom Event: unAuthNewRequestEvent',
      unAuthTopicSelectedEvent: 'Custom Event: unAuthTopicSelectedEvent',
      unAuthLoadedApolloSolutionsEvent: 'Custom Event: unAuthLoadedApolloSolutionsEvent',
      unAuthFailedToLoadApolloSolutionEvent: 'Custom Event: unAuthFailedToLoadApolloSolutionEvent',
      unAuthLoadedAzureSupportSolutionEvent: 'Custom Event: unAuthLoadedAzureSupportSolutionEvent',
      unAuthFailedToLoadAzureSupportSolutionEvent: 'Custom Event: unAuthFailedToLoadAzureSupportSolutionEvent',
      unAuthSolutionFoundEvent: 'Custom Event: unAuthSolutionFoundEvent',
      unAuthSolutionNotFoundNavigateToDetailsEvent: 'Custom Event: unAuthSolutionNotFoundNavigateToDetailsEvent',
      unAuthSolutionNotFoundNavigateToBasicEvent: 'Custom Event: unAuthSolutionNotFoundNavigateToBasicEvent',
      unAuthSetBasicStateEvent: 'Custom Event: unAuthSetBasicStateEvent',
      unAuthDeepLinkEvent: 'Custom Event: unAuthDeepLinkEvent',
      unAuthEmptyVerbatimAfterEncodingEvent: 'Custom Event: unAuthEmptyVerbatimAfterEncodingEvent',
      unAuthEmptyVerbatimEvent: 'Custom Event: unAuthEmptyVerbatimEvent',
      unAuthHttpRequestEvent: 'Custom Event: unAuthHttpRequestEvent',
      unAuthHttpResponseEvent: 'Custom Event: unAuthHttpResponseEvent',
    };
  }

  get loginState() {
    return {
      unauth: 'unauth',
      auth: 'auth',
    };
  }

  get saveReport() {
    return 'Save report';
  }
  get entryHeaders() {
    return {
      msCorrelationId: 'MS-CorrelationId',
      xCorrelationId: 'X-Correlation-Id',
    };
  }

  get notAvailable() {
    return 'N/A';
  }

  get sessionContextInfoTitles() {
    return {
      sessionProperties: 'Session Properties',
      property: 'Property',
      value: 'Value',
      buildId: 'Build Id',
      sessionId: 'Session Id',
      tenantId: 'Tenant Id',
      locale: 'Locale',
      corelationId: 'FrontDoor Correlation Id',
      claims: 'Claims',
      appConfigFlights: 'App Config Flights',
      carbonFlights: 'Carbon Flights',
      activeFlights: 'Active Flights',
    };
  }

  get tracingInfoTitles() {
    return {
      tracingInfo: 'Tracing info',
      id: 'ID',
      location: 'Location',
      type: 'Type',
      tags: 'Tags',
      correlationId: 'CorrelationId',
      entry: 'Entry',
    };
  }

  get displayCssProperties() {
    return {
      displayNone: 'display-none',
      displayBlock: 'display-block',
      alignRight: 'align-right',
      colSpan8: 'col-xs-8',
      alignRightLtrLeftRtl: 'align-right-LTR-align-left-RTL',
    };
  }

  get FairfaxRequestRedirectUrl() {
    return this.settings.FairfaxRequestRedirectUrl;
  }

  get PartnerAccountInfo() {
    return 'PartnerAccountInfo';
  }

  get caseReviewType() {
    return {
      incentive: 'Incentive',
      marketplace: 'MarketPlace',
      mpn: 'ConnectUs-MPN',
    };
  }

  get BrowserStorageKeys() {
    return {
      panelFlight: 'cux-support-panel-flights',
      supportWorkspace: 'supportWorkspaceFlight',
      panelDeepLinkInfo: 'he-ext-deepLinkInfo',
    };
  }

  get ServiceDeskCaseLink() {
    return this.serviceDeskEndpoint + '/#/customer/case/';
  }

  get getPathNames() {
    return {
      PartnerV1PathName: 'dashboard/support/csp/servicerequests/create',
      PartnerV2PathName: 'dashboard/support/servicerequests/create',
      internalPathName: 'internal/tools/support/servicerequests/create', // unused
      unAuthPathName: 'support/v2', //Looks like this PathName is not being used anywhere, so /support is not needed here
    };
  }

  get getVirtualDirectory() {
    return {
      dashboardSupport: 'dashboard/support',
      internalSupport: 'internal/tools/support',
      serviceHealthStatus: 'support/csp/service-health-status',
      caseReviews: 'internal/tools/casereviews',
      unAuth: 'support/v2',
      unAuthCommon: 'support',
    };
  }

  get caseReviewServiceLink() {
    return {
      incentive:
        'https://cosmic.crm.dynamics.com/main.aspx?appid=26b90c81-f99d-e811-a95d-000d3a36c841&pagetype=entityrecord&etn=incident&id=',
      serviceDesk: this.ServiceDeskCaseLink,
      mpn: 'https://connectus.partners.extranet.microsoft.com',
      mpnAccess: 'http://aka.ms/bts',
    };
  }

  get blockCreation() {
    return 'blockcreation';
  }

  get StageFromSupportPanel() {
    return {
      s1: 'basic',
      s2: 'solution',
      s3: 'detail',
    };
  }

  get QueryStringParams() {
    return {
      topicid: 'topicid',
      IsSdPreview: 'IsSdPreview',
      isPreview: 'isPreview',
      refreshed: 'refreshed',
      unauthRedirect: 'unauthRedirect',
      isAzPreview: 'isAzPlatformPreview',
      mpnId: 'mpnid',
      tenantId: 'tid',
      supportPanel: 'supportPanel',
      setSupportFlight: 'setSupportFlight',
      preventRedirect: 'preventRedirect',
    };
  }

  get FeatureStorageQueryStringParamsAndStorageKey() {
    return {
      setPreview: 'preview-enabled-features',
    };
  }

  get enabledSupportOptionsInPC() {
    return {
      phone: 'Phone',
      web: 'Web',
      email: 'Email',
    };
  }

  get ticketingSystem() {
    return {
      cosmic: 'Cosmic',
      serviceDesk: 'ServiceDesk',
    };
  }

  get sessionStorageKeys() {
    return {
      programList: 'ProgramList',
      notificationPreferences: 'NotificationPreferences',
    };
  }

  get ProgramClaims() {
    return {
      commercialClaim: 'Commercial',
      nonCommercialClaim: 'NonCommercial',
      commercialAndNonCommercialClaim: 'CommercialAndNonCommercial',
    };
  }

  get ControlTypes() {
    return {
      dropDown: 'DROPDOWN',
      dateTimePicker: 'DATETIMEPICKER',
      textBox: 'TEXTBOX',
      multiLineTextBox: 'MULTILINETEXTBOX',
      infoBlock: 'INFOBLOCK',
      multiSelectDropDown: 'MULTISELECTDROPDOWN',
      numerictextbox: 'NUMERICTEXTBOX',
      radioButton: 'RADIOBUTTONGROUP',
    };
  }

  get ValidationTypes() {
    return {
      minValue: 'MINVALUE',
      maxValue: 'MAXVALUE',
      regExMatch: 'REGEXMATCH',
      notRegExMatch: 'NOTREGEXMATCH',
      greaterThan: 'GREATERTHAN',
      lessThan: 'LESSTHAN',
      contains: 'CONTAINS',
      notContains: 'NOTCONTAINS',
      containsCharacters: 'CONTAINSCHARACTERS',
      notContainsCharacters: 'NOTCONTAINSCHARACTERS',
      hasLetter: 'HASLETTER',
      hasUpperCaseLetter: 'HASUPPERCASELETTER',
      hasLowerCaseLetter: 'HASLOWERCASELETTER',
      hasPunctuation: 'HASPUNCTUATION',
      minLength: 'MINLENGTH',
      maxLength: 'MAXLENGTH',
      caseInsensitiveComparison: 'CASEINSENSITIVECOMPARISON',
      email: 'EMAIL',
    };
  }

  get AdditionalInfoTypes() {
    return {
      scopingQuestion: 'ScopingQuestionInfo',
      partnerAccountInfo: 'PartnerAccountInfo',
      browserInfo: 'BrowserInfo',
      agentNotes: 'AgentNote',
      caseUri: 'CaseUri',
    };
  }

  get RepairItemTags() {
    return {
      incentives: 'IncentivesCaseReview',
      csp: 'CSPCaseReview',
      mpn: 'MPNCaseReview',
      marketplace: 'MarketplacePublisherCaseReview',
      rideAlong: 'RideAlong',
    };
  }

  get RepairItemAreaPaths() {
    return {
      opExMbo: 'OSGS\\\\PartnerExperience\\\\Operational Excellence\\\\MBO',
      opExCss: 'OSGS\\\\PartnerExperience\\\\Operational Excellence\\\\CSS',
      contentSuffix: '\\\\Content - PM',
      incentivesProgram: 'OSGS\\\\PartnerExperience\\\\Incentives', //todo: sap doesn't exist
      cspProgram:
        'OSGS\\\\PartnerExperience\\\\Customers, Relationships, Transactions, Management\\\\Transact and Manage',
      mpnProgram: 'OSGS\\\\PartnerExperience\\\\MPN Program and Benefits',
      referralsProgram: 'OSGS\\\\PartnerExperience\\\\Referrals and Cosell',
      marketplaceProgram: 'OSGS\\\\PartnerExperience\\\\Ingestion Experience', //todo: sap doesn't exist
      supportExperience: 'OSGS\\\\PartnerExperience\\\\Portal and Support Platform\\\\Support Experience',
      rob: 'OSGS\\\\PartnerExperience\\\\PXRB- PX Rhythm and Business Management',
    };
  }

  get BrowserInfo() {
    return {
      browserInfo: 'BrowserInfo',
    };
  }

  get RepairItemCategory() {
    return {
      ProductImprovements: 'Product Improvements',
      ProductDocumentation: 'Product Documentation',
      SupportTopics: 'Support Topics',
      ErrorMsgImprovements: 'Error Msg Improvements',
      ScopingQuestions: 'Scoping Questions',
      OperationalExcellence: 'Operational Excellence',
      TSGs: 'TSGs',
    };
  }

  get CaseProgram() {
    return {
      Csp: 'csp',
      Mpn: 'mpn',
      Incentives: 'incentives',
      Referrals: 'referrals',
      Marketplace: 'marketplace',
      CommercialMarketplace: 'ommercialmarketplace',
    };
  }

  get DayToMilliSecondsFactor() {
    return {
      factor: 24 * 60 * 60 * 1000,
    };
  }
  get EngagementPreferencesAPIPath() {
    return {
      PreferencesPath: 'dashboard/engagementapi/identity/preferences',
      KeysSupport: '?keys=support',
    };
  }

  get ServiceRequestDefaultSettings() {
    return {
      OffSet: '0',
      SearchField: 'status',
      Open: 'Open',
      DefaultPageSize: '100',
      SupportTopicIdFieldName: 'SupportTopicId',
      Equals: 'Equals',
      DataType: 'String',
    };
  }

  get TaskMenuItemGroupIds() {
    return {
      DefaultTaskMenuItemGroup: 'DefaultTaskMenuItemGroup',
      SupportDetailsTaskMenuGroup: 'SupportDetailsTaskMenuGroup',
      CommerceCustomerTaskMenuGroup: 'CommerceCustomerGroup',
      CommerceCommonGroup: 'CommerceCommonGroup',
    };
  }

  get TaskMenuItemId() {
    return {
      details: 'ws-support-partnerservicerequestsdetails',
      activity: 'ws-support-partnerservicerequestsactivity',
      landigPage: 'ws-support-partnercentertickets',
      serviceHealth: 'ws-support-partnercenterstatus',
    };
  }

  get SpaTransitionHelperElementId() {
    return {
      landingPageId: 'taskmenu-landingPage',
      serviceHealthPageId: 'taskmenu-serviceHealth',
      activityTaskMenuId: 'activityTaskMenu',
      detailsTaskMenuId: 'detailsTaskMenu',
      customerLandingPageIdBreadcrumb: 'breadcrumb-customerLandingPage',
    };
  }

  get ServiceHealthIds() {
    return new Set<string>([
      '1bd2a485-21b4-1085-4854-76b5b13a6c8f',
      '16b1f772-6354-4d97-5901-274126e154de',
      '99b197d0-bc63-13da-cf90-5c6b06175501',
      'a7194f58-f491-cec9-8cb1-736f516ff9ae',
      'fdf3e3ee-d334-806d-5ab4-0a519a1f3d05',
      'b13ac5ef-6423-c7d6-7151-1fa89016d8d3',
      '89a763db-8e78-30a6-bd3e-daadc8f90b88',
      '177ef1d1-4185-0bd7-0300-23d775d15eeb',
      'b7273e38-bab2-0616-9afc-c7d73c72647c',
      'b855d1c0-3316-89b1-19b9-94cbae6a82d0',
      'fd8d33dd-46bd-983f-7a9b-04fe154ce5ce',
      '87300b77-0fee-6e86-f7a9-8768cbca4998',
      '075bde9b-9581-5c88-c782-2fe3fe68173f',
      'd46c37f4-8330-3366-8979-f4828da9cd87',
    ]);
  }

  get SecurityGroupUnauthorizedMessages() {
    return {
      CaseReview:
        'You are not authorized to access the case review system externally. <br> Please connect to CorpNet or request permission to join the casereviewers security group.',
      BulkCaseReviewAssignment:
        'You are not authorized to access the case review assignment system. <br> Please request permission to join the Bulkcasereviewassigners security group.',
    };
  }

  get TeamsMeetingRegex() {
    return '\\r\\nhttps://teams.microsoft.com.*\\r\\n';
  }

  get language() {
    return {
      English: 'en',
    };
  }

  get GDAPRoles() {
    return new Set<string>([
      '9b895d92-2cd3-44c7-9d02-a6ac2d5ea5c3', // Application Administrator
      'c4e39bd9-1100-46d3-8c65-fb160da0071f', // Authentication Administrator
      '0526716b-113d-4c15-b2c8-68e3c22b9f80', // Authentication Policy Administrator
      '7495fdc4-34c4-4d15-a289-98788ce399fd', // Azure Information Protection Administrator
      'b0f54661-2d74-4c50-afa3-1ec803f12efe', // Billing Administrator
      '158c047a-c907-4556-b7ef-446551a6b5f7', // Cloud Application Administrator
      '17315797-102d-40b4-93e0-432062caca18', // Compliance Administrator
      'e6d1a23a-da11-4be4-9570-befc86d067a7', // Compliance Data Administrator
      '38a96431-2bdf-4b4c-8b6e-5d3d8abac1a4', // Desktop Analytics Administrator
      '8329153b-31d0-4727-b945-745eb3bc5f31', // Domain Name Administrator
      '44367163-eba1-44c3-98af-f5787879f96a', // Dynamics 365 Administrator
      '3f1acade-1e04-4fbc-9b69-f0302cd84aef', // Edge Administrator
      '29232cdf-9323-42fd-ade2-1d097af3e4de', // Exchange Administrator
      '62e90394-69f5-4237-9190-012177145e10', // Global Administrator
      'fdd7a751-b60b-444a-984c-02652fe8fa1c', // Groups Administrator
      '729827e3-9c14-49f7-bb1b-9608f156bbb8', // Helpdesk Administrator
      '8ac3fc64-6eca-42ea-9e69-59f4c7b60eb2', // Hybrid Identity Administrator
      'eb1f4a8d-243a-41f0-9fbd-c7cdf6c5ef7c', // Insights Administrator
      '3a2c62db-5318-420d-8d74-23affee5d9d5', // Intune Administrator
      '74ef975b-6605-40af-a5d2-b9539d836353', // Kaizala Administrator
      'b5a8dcf3-09d5-43a9-a639-8e29ef291470', // Knowledge Administrator
      '744ec460-397e-42ad-a462-8b3f9747a02c', // Knowledge Manager
      'd24aef57-1500-4070-84db-2666f29cf966', // Modern Commerce User
      '2b745bdf-0803-4d80-aa65-822c4493daac', // Office Apps Administrator
      '4ba39ca4-527c-499a-b93d-d9b492c50246', // Partner Tier1 Support
      'e00e864a-17c5-4a4b-9c06-f5b95a8d5bd8', // Partner Tier2 Support
      'a9ea8996-122f-4c74-9520-8edcd192826c', // Power BI Administrator
      '11648597-926c-4cf3-9c36-bcebb0ba8dcc', // Power Platform Administrator
      '7be44c8a-adaf-4e2a-84d6-ab2649e08a13', // Privileged Authentication Administrator
      '0964bb5e-9bdb-4d7b-ac29-58e794862a40', // Search Administrator
      '194ae4cb-b126-40b2-bd5b-6091b380977d', // Security Administrator
      '5f2222b1-57c3-48ba-8ad5-d4759f1fde6f', // Security Operator
      'f023fd81-a637-4b56-95fd-791ac0226033', // Service Support Administrator
      'f28a1f50-f6e7-4571-818b-6a12f2af6b6c', // SharePoint Administrator
      '75941009-915a-4869-abe7-691bff18279e', // Skype for Business Administrator
      '69091246-20e8-4a56-aa4d-066075b2a7a8', // Teams Administrator
      'baf37b3a-610e-45da-9e62-d9d1e5e8914b', // Teams Communications Administrator
      'fe930be7-5e62-47db-91af-98c3a49a38b1', // User Administrator
      '11451d60-acb2-45eb-a7d6-43d0f0125c13', // Windows 365 Administrator
    ]);
  }

  get GDAPDropdownLinks() {
    return [
      {
        id: 'Azure',
        groupName: 'Azure',
        links: {
          serviceTicket: {
            uri: 'https://portal.azure.com/{customerTenantId}#blade/Microsoft_Azure_Support/HelpAndSupportBlade',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: true,
      },
      {
        id: 'Adallom',
        groupName: 'Adallom',
        links: {
          serviceTicket: {
            uri: 'https://support.microsoft.com/en-us/getsupport?wf=0&tenant=ClassicCommercial&oaspworkflow=start_1.0.0.0&locale=en-us&supportregion=en-us&pesid=16031&ccsid=635950364293309355',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: false,
      },
      {
        id: 'DynamicsPPAC',
        groupName: 'DynamicsPPAC',
        links: {
          serviceTicket: {
            uri: 'https://admin.powerplatform.microsoft.com/account/login/{customerTenantId}/support?newTicket=true',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: true,
      },
      {
        id: 'Dynamics',
        groupName: 'Dynamics',
        links: {
          serviceTicket: {
            uri: 'https://lcs.dynamics.com/Logon/Adlogon?ctid={customerTenantId}&redirecturl=https://support.lcs.dynamics.com/incidentslist/listindex',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: true,
      },
      {
        id: 'Office',
        groupName: 'Office',
        links: {
          serviceTicket: {
            uri: 'https://portal.office.com/Partner/BeginClientSession.aspx?CTID={customerTenantId}&CSDEST=Support',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: true,
      },
      {
        id: 'Intune',
        groupName: 'Intune',
        links: {
          serviceTicket: {
            uri: 'https://portal.office.com/Partner/BeginClientSession.aspx?CTID={customerTenantId}&CSDEST=Support',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: true,
      },
      {
        id: 'Windows',
        groupName: 'Windows',
        links: {
          serviceTicket: {
            uri: 'https://portal.office.com/Partner/BeginClientSession.aspx?CTID={customerTenantId}&CSDEST=Support',
            method: 'GET',
            headers: [],
          },
        },
        gdapEnabled: true,
      },
    ];
  }

  get AppointmentDocLink() {
    return 'https://docs.microsoft.com/partner-center/schedule-support-appointment';
  }

  get SupportPanelEvents() {
    return {
      redirectListPage: 'he-support-request-redirect',
      ticketCreation: 'he-support-ticket-created',
      supportPanelShow: 'he-support-panel-show',
      supportPanelHide: 'he-support-panel-hide',
    };
  }

  get GetHelpLink() {
    return 'https://docs.microsoft.com/en-us/partner-center/report-problems-with-partner-center';
  }

  get AdoRepairItemsAreaPath() {
    return {
      [WorkspacePC.Customers]:
        'OSGS\\PartnerExperience\\Customers, Relationships, Transactions, Management\\Transact and Manage',
      [WorkspaceCategoryPC.AccountSettings]: 'OSGS\\PartnerExperience\\Accounts',
      [WorkspaceCategoryPC.ActionCenter]: 'OSGS\\PartnerExperience\\Accounts\\Action Center',
      [WorkspacePC.Benefits]: 'OSGS\\PartnerExperience\\MPN Program and Benefits',
      [WorkspacePC.Billing]: 'OSGS\\PartnerExperience\\Microsoft Earnings Manager\\CSP- Billing',
      [WorkspaceCategoryPC.Enrollment]: 'OSGS\\PartnerExperience\\Accounts',
      [WorkspacePC.Insights]: 'OSGS\\PartnerExperience\\Business Insights',
      [WorkspacePC.Incentives]: 'OSGS\\PartnerExperience\\Customers, Relationships, Transactions',
      [WorkspacePC.MarketplaceOffers]: 'OSGS\\CMX\\Experience\\3PP Ingestion\\3PP UX',
      [WorkspacePC.Membership]: 'OSGS\\PartnerExperience\\MPN Program and Benefits',
      [WorkspacePC.Earnings]: 'OSGS\\PartnerExperience\\Incentives Data Platform\\Partner and Seller Payouts',
      [WorkspacePC.Pricing]: 'OSGS\\PartnerExperience\\Microsoft Earnings Manager\\CSP-Pricelist',
      [WorkspacePC.Referrals]:
        'OSGS\\PartnerExperience\\Customer, Relationship, Transaction, Management\\MECh Deal Reg ISV Connect',
      [WorkspaceCategoryPC.ApisAndIntegration]:
        'OSGS\\PartnerExperience\\Customers, Relationships, Transactions, Management\\Transact and Manage',
      [WorkspaceMSX.AccountPlans]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceMSX.Accounts]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceMSX.Contacts]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceMSX.Opportunities]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceMSX.Partners]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceMSX.Leads]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceCategoryMSX.UserProvisioning]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
      [WorkspaceMSX.Proposals]: 'OSGS\\PartnerExperience\\Lead To Order\\Portal',
      [WorkspaceMSX.SalesAccelerator]: 'OSGS\\PartnerExperience\\PXRB- PX Rhythm and Business Management',
    };
  }

  get TopSupportTopics() {
    return [
      '4f80f253-4d78-ea9a-ab3e-15082b26359e',
      '6fdf1eed-5667-c834-1518-59c6eb298deb',
      'f6d4d9aa-acd2-f7e2-ad7e-1fb5e07f20cf',
      '106cecbb-8627-c445-2538-7447f5df7b29',
      '2660fd72-0cb0-02ca-a248-e4565cb66371',
      'a7b77b19-2490-0473-2d99-e2075f48adb4',
      '89465c12-ccb6-4d8f-57a4-ffe9f85f64a4',
      'd2a2befe-a177-4f14-2c70-a2599dbb7163',
      'c8d9ba74-edb8-835c-8cb8-abeaf158ba1a',
      '74d9b329-6576-c3da-01f5-bb0c52c90fc8',
      '232476f8-3d85-0c46-dfe5-4a0195881cf2',
    ];
  }
}
